import React from "react";

import banniere from "../asset/bannierepopup.webp";

const ConsentPopup = ({ onAccept, onDecline }) => {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-2xl w-[90%] max-w-lg z-[1000] font-sans overflow-hidden">
      {/* Image */}
      <div>
        <img
          src={banniere}
          alt="Communauté joyeuse"
          className="w-full h-auto"
        />
      </div>

      {/* Texte */}
      <div className="p-5">
        <h3 className="text-lg text-gray-800 mb-4 text-center font-semibold">
          ✨ <strong>Votre quotidien plus simple et plus joyeux !</strong>
        </h3>
        <p className="text-sm text-gray-600 mb-5 text-center leading-relaxed">
          Rejoignez notre communauté et soyez les premiers informés des offres
          exclusives et des réductions jusqu'à <strong>60%</strong> sur les
          Parcs, vacances, cinéma, spectacles…
        </p>

        {/* Options */}
        <div className="text-center space-y-4">
          <label className="flex items-center justify-center text-sm text-gray-800 cursor-pointer hover:text-theme-accent transition-colors">
            <input
              type="checkbox"
              className="w-5 h-5 mr-3 text-theme-accent bg-gray-100 border-gray-300 rounded focus:ring-theme-accent focus:ring-2"
              onChange={onAccept}
            />
            <span className="font-medium">Oui, je le veux</span>
          </label>
          <label className="flex items-center justify-center text-sm text-gray-800 cursor-pointer hover:text-theme-accent transition-colors">
            <input
              type="checkbox"
              className="w-5 h-5 mr-3 text-theme-accent bg-gray-100 border-gray-300 rounded focus:ring-theme-accent focus:ring-2"
              onChange={onDecline}
            />
            <span className="font-medium">
              Je ne souhaite pas en bénéficier
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ConsentPopup;
